import React from 'react';
import { Switch } from '@mui/material';

export default function PaymentMethodRow({
  label,
  name,
  checked,
  onChange,
  onDivClick,
  disabled,
}) {
  return (
    <span
      style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
      onClick={!disabled ? onDivClick : undefined}>
      <label style={{ flex: 1, cursor: 'pointer' }}>{label}</label>
      <Switch
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={(value) =>
          onChange({
            target: {
              name: name,
              value: value.target.checked,
            },
          })
        }
      />
    </span>
  );
}
